<template>
  <section v-if="rfq">
    <h1>Environmental Impact</h1>
    <div class="flex--column flex--justify-center"> 
      <div class="image-wrapper py-3">
        <div class="text-desc">
          <div class="ei-number">
            {{ totEnergy | commasep(0) }} 
            <span class="ei-unit">kWh</span>
          </div>
          <div class="ei-desc">
            Green Energy Produced from project in one year
          </div>
        </div>
        <div class="logo-wrapper">
          <img 
            src="https://camas.app/resources/static/images/images/image__cb9f128fac969522aa3e90250313ec77.png"/>
          <div class="straight-line dark-blue">
          </div>
        </div>
        <div class="text-desc">
          <div class="ei-number text--nowrap">
            {{ totEnergy * 30 | commasep(0)}} 
            <span class="ei-unit">kWh</span>
          </div>
          <div class="ei-desc">
            Green Energy Produced from project in a 30 year period
          </div>
        </div>
        <div class="equals-to">
          =
        </div>
      </div>

      <div class="image-wrapper mt-1">
        <div class="text-desc">
          <div class="ei-number">
            {{ totEnergy / 1000 * estimation.metric_tones_co2_ratio | commasep(0) }} 
          </div>
          <div class="ei-desc">
            Tonnes of CO2 in one year
          </div>
        </div>
        <div class="logo-wrapper">
          <img 
            src="https://camas.app/resources/static/images/images/image__379358f60698bce726a2db266d005efd.png"/>
          <!-- <div class="straight-line light-blue">
          </div> -->
        </div>
        <div class="text-desc">
          <div class="ei-number">
            {{ totEnergy / 1000 * estimation.metric_tones_co2_ratio * 30 | commasep(0) }}
          </div>
          <div class="ei-desc">
            Tonnes of CO2 in a 30 year period
          </div>
        </div>
      </div>

      <div class="image-wrapper">
        <div class="text-desc">
          <div class="ei-desc">
            Electricity for 
          </div>
          <div class="ei-number">
            {{ totEnergy / 1000 * estimation.elec_homes_ratio | commasep(0) }}
          </div>
          <div class="ei-desc">
            Homes in one year
          </div>
        </div>
        <div class="logo-wrapper">
          <img
            src="https://camas.app/resources/static/images/images/image__2bc1a28dfa1f034b05bfdc99f6777d1e.png"/>
          <!-- https://camas.app/resources/static/images/images/image__1c8b6f3e6a275a22c14118e3b4bf9bea.jpg -->
          <!-- <div class="straight-line orange">
          </div> -->
        </div>
        <div class="text-desc">
          <div class="ei-desc">
            Electricity for 
          </div>
          <div class="ei-number">
            {{ totEnergy / 1000 * estimation.elec_homes_ratio * 30 | commasep(0) }} 
          </div>
          <div class="ei-desc">
            Homes in a 30 year period
          </div>
        </div>
      </div>

      <div class="image-wrapper">
        <div class="text-desc">
          <div class="ei-number">
            {{ totEnergy / 1000 * estimation.no_of_trees_ratio | commasep(0) }} 
          </div>
          <div class="ei-desc">
            Trees planted in one year
          </div>
        </div>
        <div class="logo-wrapper">
          <img 
            src="https://camas.app/resources/static/images/images/image__c9a442968bf354128932dfddf54a21a3.png"/>
            <!-- https://camas.app/resources/static/images/images/image__d1e7b33beac829628091b421121a25ac.jpg -->
          <!-- <div class="straight-line dark-blue">
          </div> -->
        </div>
        <div class="text-desc">
          <div class="ei-number">
            {{ totEnergy / 1000 * estimation.no_of_trees_ratio * 30 | commasep(0) }} 
          </div>
          <div class="ei-desc">
            Trees planted in a 30 year period
          </div>
        </div>
      </div>
      <div class="image-wrapper">
        <div class="text-desc">
          <div class="ei-number">
            {{ totEnergy / 1000 * estimation.cars_per_year_ratio | commasep(0) }}
          </div>
          <div class="ei-desc">
            Cars off the Road in one year
          </div>
        </div>
        <div class="logo-wrapper">
          <img
            src="https://camas.app/resources/static/images/images/image__d61b1db93222d9e5ddacc5f5956c98ed.png"/>
            <!-- https://camas.app/resources/static/images/images/image__8ab72e769402ee2aa40dabc475e3dc46.jpg -->
          <!-- <div class="straight-line light-blue">
          </div> -->
        </div>
        <div class="text-desc">
          <div class="ei-number">
            {{ totEnergy / 1000 * estimation.cars_per_year_ratio * 30 | commasep(0) }}
          </div>
          <div class="ei-desc">
            Cars off the Road in a 30 year period
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    rfq: {
      type: Object
    }
  },
  data() {
    return {
      elevationMap: {
        'North': 'sunlight_n', 
        'South': 'sunlight_s',
        'East': 'sunlight_e',
        'West': 'sunlight_w',
        'N/ East': 'sunlight_ne',
        'N/ West': 'sunlight_nw', 
        'S/ East': 'sunlight_se', 
        'S/ West': 'sunlight_sw'
      },
      sunHourFields: [
        'sunlight_e', 'sunlight_n', 'sunlight_ne', 'sunlight_nw',
        'sunlight_s', 'sunlight_se', 'sunlight_sw', 'sunlight_w'
      ]
    }
  },
  computed: {
    estimation({ rfq }) {
      return rfq.c_estimation ? rfq.c_estimation : rfq.estimation;
    },
    totEnergy({ estimation, elevationMap, sunHourFields }) {
      return estimation.estimation_summary.by_elevation.map(
        d => {
          if (d.elevation == 'Whole Building') {
            let avg = sunHourFields.map(
              elevation => estimation[elevation]
            ).reduce((a,b) => a + +b, 0) / sunHourFields.length

            return avg * d.system_capacity
          } else {
            return d.system_capacity * estimation[elevationMap[d.elevation]]
          }
        }
      ).reduce((a,b) => a + +b, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';

.text--nowrap {
  white-space: nowrap;
}

.image-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  color:#0E4E74;
  position: relative;
  .equals-to {
    color:#0E4E74;
    font-size: 2.7em;
    font-weight: bold;
    width: 100%;
    text-align: center;
    line-height: 1;
    position: absolute;
    bottom: 0px;
  }
  .text-desc {
    width: 220px;
    text-align: center;
    padding-bottom: 1em;
  }
  .ei-number {
    font-size: 1.6em;
    line-height: 1.1;
    font-weight: bold;
  }
  .ei-unit {
    font-size: 0.5em !important;
    font-weight: normal;
  }
  .ei-desc {
    font-size: 0.85em !important;
  }
  .logo-wrapper {
    position: relative;
    text-align: center;
    width: 218px;
  }
  img {
    position: relative;
    width: 218px;
    z-index: 1;
  }
}
</style>
